module.exports = __webpack_public_path__ + "img/NotFound.6aba595d.svg";